// extracted by css-extract-rspack-plugin
export default {"SectionView":"zNlHB"};